(() => {
  const init = (planner) => {
    if (planner.dataset.initialized === 'true') return;
    planner.dataset.initialized = 'true';
    const storageKey = `ef-cart-plan:${planner.dataset.customerId || 'guest'}`;
    const fields = [...planner.querySelectorAll('[data-ef-plan-field]')];
    let saved = {};
    try { saved = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (_) {}

    const updateBudget = () => {
      const budgetField = planner.querySelector('[data-ef-plan-field="budget"]');
      const budget = Math.max(Number(budgetField?.value || 1000), 1);
      const cartTotal = Number(planner.dataset.cartTotal || 0) / 100;
      const percentage = Math.min((cartTotal / budget) * 100, 100);
      const difference = Math.abs(budget - cartTotal);
      const label = planner.querySelector('[data-ef-budget-label]');
      const bar = planner.querySelector('[data-ef-budget-bar]');
      const result = planner.querySelector('[data-ef-budget-result]');
      if (label) label.textContent = budget.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
      if (bar) {
        bar.style.width = `${percentage}%`;
        bar.classList.toggle('is-over', cartTotal > budget);
      }
      if (result) {
        result.innerHTML = cartTotal <= budget
          ? `<strong>$${difference.toFixed(2)} remaining</strong><span>Your cart is within the current target.</span>`
          : `<strong>$${difference.toFixed(2)} over target</strong><span>Adjust quantities or increase your budget target.</span>`;
      }
    };

    fields.forEach((field) => {
      if (saved[field.dataset.efPlanField] !== undefined) field.value = saved[field.dataset.efPlanField];
      field.addEventListener('input', () => {
        saved[field.dataset.efPlanField] = field.value;
        try { localStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {}
        if (field.dataset.efPlanField === 'budget') updateBudget();
      });
    });

    const changeLine = async (line, quantity, button) => {
      button?.setAttribute('disabled', 'disabled');
      planner.classList.add('is-updating');
      try {
        const response = await fetch(planner.dataset.cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line, quantity }),
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (_) {
        planner.classList.remove('is-updating');
        button?.removeAttribute('disabled');
        window.alert('We could not update this item. Please refresh the page and try again.');
      }
    };

    planner.querySelectorAll('[data-ef-cart-line]').forEach((row) => {
      const line = Number(row.dataset.efCartLine);
      const quantity = Number(row.dataset.efQuantity);
      row.querySelector('[data-ef-quantity-minus]')?.addEventListener('click', (event) => changeLine(line, Math.max(quantity - 1, 0), event.currentTarget));
      row.querySelector('[data-ef-quantity-plus]')?.addEventListener('click', (event) => changeLine(line, quantity + 1, event.currentTarget));
      row.querySelector('[data-ef-remove-line]')?.addEventListener('click', (event) => changeLine(line, 0, event.currentTarget));
    });

    planner.querySelector('[data-ef-print-show]')?.addEventListener('click', () => window.print());
    updateBudget();
  };

  document.querySelectorAll('[data-ef-cart-planner]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ef-cart-planner]').forEach(init);
  });
})();
